export default (epics) => Object.values(epics)
